"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const palettes_1 = require("../palettes");
const fonts_1 = require("../typography/fonts");
const mainTheme = {
    colors: palettes_1.palette,
    typography: {
        fonts: {
            OpenSans: fonts_1.openSansRegular,
            OpenSansItalis: fonts_1.openSansBoldItalic,
            openSansSemiBold: fonts_1.openSansSemiBold,
        },
    },
    components: {
        Text: {
            baseStyle: {
                color: palettes_1.palette.text[400],
                font: fonts_1.openSansRegular,
            },
        },
        Button: {
            baseStyle: {
                bgColor: palettes_1.palette.primary[400],
                rounded: '3xl',
                fontWeight: 'medium',
            },
        },
    },
};
exports.default = mainTheme;
